import React from 'react';
import { ContractView } from '../elements/contract/ContractView';
import { EHttpMethod, usePortalQuery } from '../hooks/usePortalQuery';
import { useDefinedParams } from '../hooks/useDefinedParams';
import { Contract, EPageViewType, Group } from '../types';
import axios from 'axios';
import { EnvironmentVariables } from '../EnvironmentVariables';
import { useNavigate } from 'react-router-dom';
import { PageHeading } from '@portal_components/components/PageHeading';
import { EUserRole } from '@portal_components/types';
import { useUserInfo } from '../hooks/useUserInfo';

export const AddContractPage = () => {
  const navigate = useNavigate();
  const [groupId] = useDefinedParams(['groupId']);
  const { userInfo } = useUserInfo();
  const [formSubmitted, setFormSubmitted] = React.useState<boolean>(false);

  const { data: group, isLoading: isGroupLoading } = usePortalQuery<Group>(
    EHttpMethod.GET,
    `group/${groupId}`,
    'get-group',
    !!groupId
  );

  const handleSubmit = async (values: Contract): Promise<{ success: boolean; message: string }> => {
    setFormSubmitted(true);
    const response = await axios
      .put(
        `${EnvironmentVariables.ApiUrl}/contract`,
        { ...values, contractGroupId: group?.customerGroupId },
        {
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: true
        }
      )
      .catch(error => error.response);
    if (!response) {
      setFormSubmitted(false);
      return { success: false, message: 'An error occurred while adding contract.' };
    }
    if (response.status !== 200) {
      setFormSubmitted(false);
      return { success: false, message: response.data };
    }
    setTimeout(() => {
      navigate(`/`);
    }, 5000);
    return {
      success: true,
      message: 'Successfully added contract. You will be automatically redirected to the main page'
    };
  };

  if (!userInfo || userInfo.role === EUserRole.READONLY_USER)
    return <p className="text-center">You do not have permission to add contracts.</p>;

  return (
    <div>
      <PageHeading title="Add Contract" />
      {isGroupLoading && <div className="flex flex-row justify-center">Loading...</div>}
      {group && (
        <ContractView
          viewType={EPageViewType.ADD}
          group={group}
          contract={{}}
          onSubmit={handleSubmit}
          formSubmitted={formSubmitted}
        />
      )}
    </div>
  );
};
